import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FaqItem } from '@/hooks/useBlogDetail';

export default function BlogFAQ({ faq }: { faq: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-2 border-t border-secondary-200 pt-5">
      <h2 className="text-[18px] font-extrabold leading-[1.2] tracking-[-0.01em] text-secondary-900 lg:text-[22px]">
        {t('blog.faq')}
      </h2>
      <div className="flex flex-col">
        {faq.map((item, i) => (
          <div
            key={i}
            className="border-b border-secondary-200 last:border-b-0"
          >
            <h3 className="flex">
              <button
                type="button"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="group flex flex-1 items-center justify-between gap-3 py-4 text-left text-[15px] font-bold leading-[1.35] text-secondary-900 transition-colors hover:no-underline focus-visible:ring-0"
              >
                {item.question}
                <i
                  className={`ri-arrow-down-s-line text-lg text-primary-500 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}
                />
              </button>
            </h3>
            {openIndex === i && (
              <div className="pb-4 text-[13px] leading-[1.65] text-secondary-600">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}